// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true
};

// export const baseUrl = "https://travelzad.inovaeg.com";
// export const baseUrl = "http://localhost:3000";
export const baseUrl = "https://app.thenoorapp.com";
export let stripeKey = ""; //"pk_test_51GvkU3EO2HIsafqZ4uFm4VHjlEiG3vU7RY0AecBV2CoUXK2BBaab0gGcvkbR8BRLzakFvNy4IMvq9P46Fm1AE8Ec00PNxhSW4Y";
export  function setKey(key) {
  stripeKey = key
}
// export const stripeKey = "pk_test_ioutb8IcxXO7aNAQH7yLqfSt00hcv7ClFT";
export const plaidPublicKey = "0d3c01bfb993064ee4628ae7fabc01"
export const plaidProducts =  "['auth']"
export const plaidCountryCodes = "['US','CA','GB','FR','ES']"

export const plaidEnv= "sandbox"







